import { AppConstants } from './app-constants';

export class UITools {
	// ------------------------------------------------------------------------
	static onDivScrollHandler = (buttonId: string, divId: string, scrollPadding: number = AppConstants.scrollToTopPadding) => {
		const theButton = document.getElementById(buttonId);
		const theDiv = document.getElementById(divId);

		// var note = document.getElementsByName('Note')[0];

		if (theButton && theDiv) {
			if (theDiv.scrollTop > scrollPadding) {
				// console.log('show button ' + buttonId);
				theButton.classList.remove('d-none');
			} else {
				// console.log('hide button ' + buttonId);
				theButton.classList.add('d-none');
			}
		} else {
			console.log('cannot get button or div');
		}
	}

	// ------------------------------------------------------------------------
	static onPageScrollHandler = (buttonId: string = AppConstants.scrollToTopButtonId) => {
		const theButton = document.getElementById(buttonId);
		if (theButton) {
			if (document.body.scrollTop > AppConstants.scrollToTopPadding || document.documentElement.scrollTop > AppConstants.scrollToTopPadding) {
				// console.log('show button ' + buttonId);
				theButton.classList.remove('d-none');
			} else {
				// console.log('hide button ' + buttonId);
				theButton.classList.add('d-none');
			}
		} else {
			console.log('cannot get button ' + buttonId);
		}
	}

	// --------------------------------------------------------------------
	static scrollToSpot = (id: string) => {
		const el: HTMLElement | null = document.getElementById(id);
		if (el) {
			setTimeout(() =>
				el.scrollIntoView({ block: 'start', inline: 'nearest' }), 0);
		} else {
			console.log('Cannot find el ' + id);
		}
	} // scrollToSpot

	// ------------------------------------------------------------------------
	static clickButton = (id: string, blurAfter: boolean = false) => {
		// this.debugMessage('click ' + id);
		if (document.getElementById(id)) {
			// this.debugMessage('clicking ' + id);
			document.getElementById(id).click();
			if (blurAfter) document.getElementById(id).blur();
		} else {
			console.error('Cannot clickButton "' + id + '"');
		} // if
	} // clickButton

	// ------------------------------------------------------------------------
	static focusOn = (id: string) => {
		if (document.getElementById(id)) {
			document.getElementById(id).focus();
		} else {
			console.error('Cannot focusOn "' + id + '"');
		} // if
	} // focusOn

	// ------------------------------------------------------------------------
	static removeFocus = (id: string) => {

		if (document.getElementById(id)) {
			document.getElementById(id).blur();
		} else {
			console.error('Cannot removeFocus "' + id + '"');
		} // if
	} // removeFocus
};